<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="!formData.id?'新增角色':'编辑角色'"
    custom-class="project-dialog"
    :visible.sync="dialogVisible"
    :lock-scroll="false"
    width="60%"
  >
    <div class="px-xs">
      <el-form
        :model="formData"
        :rules="rules"
        ref="form"
        label-width="100px"
      >
        <el-form-item
          label="角色名称"
          prop="name"
        >
          <el-input
            v-model="formData.name"
            max="15"
            min="2"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="设置权限"
          prop="authority"
        >
          <el-checkbox-group v-model="formData.authority">
            <ul class="authority-box">
              <li
                v-for="(item,index) in menuList"
                :key="index"
              >
                <div>
                  {{item.name}}
                </div>
                <div>
                  <el-checkbox
                    :label="item.path"
                    v-for="(item,index) in item.children"
                    :key="index"
                  >{{item.name}}</el-checkbox>
                </div>
              </li>
            </ul>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="dialogVisible = false"
        size="small"
      >取 消</el-button>
      <el-button
        type="primary"
        @click="submitForm"
        size="small"
      >确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "addRole",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
    registTime: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
    visible: {
      handler(value) {
        this.dialogVisible = value;
      },
      immediate: true,
    },
  },
  filters: {},
  data() {
    return {
      checkList: [],
      menuList: this.$store.state.menuList,
      dialogVisible: this.visible,
      // 绑定表单数据
      formData: JSON.parse(JSON.stringify(this.value)),
      rules: {
        name: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur",
          },
          { min: 2, max: 15, message: "长度在 2 到 15个字符", trigger: "blur" },
        ],
        authority: [
          {
            required: true,
            message: "请选择权限",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    submitForm() {
      // 表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http
            .post("/sys/saveRole", {
              ...this.formData,
            })
            .then((res) => {
              if (res.data.code == -1) {
                this.$message.error(res.data.message);
                return;
              } else {
                this.$message.success("已保存");
                this.dialogVisible = false;
                this.$emit("submitForm");
              }
            })
            .catch((err) => {
              this.$message.error("保存失败");
              this.dialogVisible = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang='less' scoped>
</style>